import { z } from 'zod';

/////////////////////////////////////////
// CORE LOCATION SCHEMA
/////////////////////////////////////////

export const CoreLocationSchema = z.object({
  id: z.number().int(),
  cityId: z.number().int(),
  parcelNumber: z.string(),
  locationAddressId: z.number().int().nullable(),
  locationName: z.string().nullable(),
  ownerName: z.string().nullable(),
  ownerAddressId: z.number().int().nullable(),
  ownerEmail: z.string().nullable(),
  ownerPhone: z.string().nullable(),
  lotSize: z.number().nullable(),
  zoning: z.string().nullable(),
  yearBuilt: z.number().int().nullable(),
  buildingTypeId: z.number().int().nullable(),
  deactivatedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  rowTimestamp: z.coerce.date(),
  externalId: z.string().nullable(),
})

export type CoreLocation = z.infer<typeof CoreLocationSchema>

export default CoreLocationSchema;
